// src/utils/emailSignature.ts

const LATAM_TOLL_FREE_CUSTOMERS = ["Conecel", "Claro Nicaragua", "TIM Brazil", "Telebras"];

const normalizeCustomers = (affectedCustomer?: string | string[] | null): string[] => {
    const raw = Array.isArray(affectedCustomer) ? affectedCustomer : [affectedCustomer ?? ""];
    return raw
        .flatMap(c => String(c ?? "").split(","))
        .map(c => c.trim().toLowerCase())
        .filter(Boolean);
};

/**
 * Returns the body of the email signature (the lines after
 * "Managed Services Operations") for the given customer(s).
 */
export const getSignatureLines = (
    affectedCustomer?: string | string[] | null,
    linkColor = "#2a1364"
): string => {
    const customers = normalizeCustomers(affectedCustomer);
    const mailLink = (email: string) =>
        `<a href="mailto:${email}" style="color: ${linkColor};">${email}</a>`;

    if (customers.includes("petrobras")) {
        return `SES VAS ICMS<br>
            Whatsapp msg: +41 225521085<br>
            Brazilian toll-free number: +551121975533<br>
            Email: ${mailLink("support.latam@bcomintelsat.com")}`;
    }

    if (customers.some(c => LATAM_TOLL_FREE_CUSTOMERS.some(l => l.toLowerCase() === c))) {
        return `SES VAS ICMS<br>
            Swiss Tel. & Whatsapp msg: +41 225521085<br>
            Ecuadorian toll-free number: +593 1800 400 488<br>
            Brazilian toll-free number: +553 133 064 628<br>
            Email: ${mailLink("support@bcomintelsat.com")}`;
    }

    return `SES VAS ICMS<br>
            Tel. & Whatsapp msg: +41 225521085<br>
            Email: ${mailLink("support@bcomintelsat.com")}`;
};
